export default "__VITE_ASSET__pDiEtZ0z__"